/**
 * Route: Create Custom Recipe Page with Container + View Pattern
 * 
 * This is a route-level component that delegates to the centralized 
 * Container + View pattern for clean separation of concerns
 */
import CreateCustomRecipePageContainer from './CreateCustomRecipePage.container';

export function CreateCustomRecipePage() {
  // Route level just delegates to container - clean and simple
  return <CreateCustomRecipePageContainer />;
}